import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "@sentricmusic/ui";
import { useTranslation } from "react-i18next";

type GigsClaimAlertsProps = {
  isDenmarkAlertOpen: boolean;
  setIsDenmarkAlertOpen: (open: boolean) => void;
  isUsAlertOpen: boolean;
  setIsUsAlertOpen: (open: boolean) => void;
};

export default function GigsClaimAlerts({
  isDenmarkAlertOpen,
  setIsDenmarkAlertOpen,
  isUsAlertOpen,
  setIsUsAlertOpen,
}: GigsClaimAlertsProps) {
  const { t } = useTranslation(["gigs", "common"]);

  return (
    <>
      <Dialog open={isDenmarkAlertOpen} onOpenChange={setIsDenmarkAlertOpen}>
        <DialogContent showCloseButton>
          <DialogTitle>{t("gigs:denmark-gig-alert-title", "Important notice")}</DialogTitle>
          <DialogDescription>
            {t("gigs:denmark-gig-alert", "To ensure you receive royalties, please report performances in Denmark no later than 1 month after the performance. Anything after that we cannot guarantee royalties will be distributed by KODA.")}
          </DialogDescription>
          <DialogFooter>
            <Button
              variant="primary"
              label={t("common:ok", "OK")}
              onClick={() => setIsDenmarkAlertOpen(false)}
            />
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={isUsAlertOpen} onOpenChange={setIsUsAlertOpen}>
        <DialogContent showCloseButton>
          <DialogTitle>{t("gigs:us-gig-alert-title", "Important notice")}</DialogTitle>
          <DialogDescription>
            {t("gigs:us-gig-alert", "If you're a member of BMI/ASCAP/SESAC please register the gig claim directly on your PRO account. Overseas publishers like Sentric are not able to submit a gig that has occurred in the US on behalf of a US society writer/non-society writer.\nIf you are a member of any other PRO please add the gig details to your Sentric account.\nIf you are not a member of a PRO we suggest registering with your local PRO.")}
          </DialogDescription>
          <DialogFooter>
            <Button
              variant="primary"
              label={t("common:ok", "OK")}
              onClick={() => setIsUsAlertOpen(false)}
            />
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
